import React from "react";
import { Link } from "react-router-dom";
import { useRemoteRegistry } from "../registry/RemoteRegistryContext";
import { iconRegistry } from "./iconRegistry";

export function Home() {
  const { allRemotes } = useRemoteRegistry();

  if (allRemotes.length === 0) {
    return (
      <div style={{ padding: "2rem" }}>
        <h2 style={{ marginBottom: "0.5rem" }}>No apps registered</h2>
        <p style={{ color: "#555" }}>
          Add entries to <code>remotes.config.json</code> to register remote apps.
        </p>
      </div>
    );
  }

  return (
    <div style={{ padding: "2rem" }}>
      <h2 style={{ marginBottom: "1.5rem", fontSize: "1.1rem", fontWeight: 600, color: "#111" }}>Apps</h2>
      <div style={{ display: "flex", flexWrap: "wrap", gap: "1rem" }}>
        {allRemotes.map((remote) => {
          const Icon = iconRegistry[remote.icon] ?? iconRegistry["LayoutDashboard"];
          return (
            <Link
              key={remote.name}
              to={remote.route}
              style={{ textDecoration: "none" }}
            >
              <div
                style={{
                  width: 160,
                  padding: "1.5rem 1rem",
                  borderRadius: 8,
                  border: "1px solid #e0e0e0",
                  background: "#fff",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  gap: "0.75rem",
                  cursor: "pointer",
                  transition: "box-shadow 0.15s, border-color 0.15s",
                }}
                onMouseEnter={(e) => {
                  (e.currentTarget as HTMLDivElement).style.boxShadow = "0 2px 8px rgba(0,0,0,0.1)";
                  (e.currentTarget as HTMLDivElement).style.borderColor = "#136945";
                }}
                onMouseLeave={(e) => {
                  (e.currentTarget as HTMLDivElement).style.boxShadow = "none";
                  (e.currentTarget as HTMLDivElement).style.borderColor = "#e0e0e0";
                }}
              >
                <div style={{
                  width: 48,
                  height: 48,
                  borderRadius: 12,
                  background: "#e6f3ed",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  color: "#136945",
                }}>
                  <Icon size={24} />
                </div>
                <span style={{ fontSize: "0.85rem", fontWeight: 500, color: "#111", textAlign: "center" }}>
                  {remote.label}
                </span>
              </div>
            </Link>
          );
        })}
      </div>
    </div>
  );
}
